import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/libs/cn'
import { FormSectionCard } from '@/shared/ui/form-section-card'
import { SectionSaveButton } from '@/shared/ui/section-save-button'
import { TourImageField } from './tour-image-field'

interface ImagesCardProps {
  isEdit: boolean
  isFormReady: boolean
  banner: string | undefined
  thumbnail: string | undefined
  onBannerChange: (url: string) => void
  onThumbnailChange: (url: string) => void
  onBannerUploadingChange: (uploading: boolean) => void
  onThumbnailUploadingChange: (uploading: boolean) => void
  onPreview: (url: string) => void
  isDirty: boolean
  isSaving: boolean
  /** Save is blocked while the tour is updating or an upload is still running. */
  isSaveBlocked: boolean
  onSave: () => void
}

/** Banner and thumbnail of the tour. */
export function ImagesCard({
  isEdit,
  isFormReady,
  banner,
  thumbnail,
  onBannerChange,
  onThumbnailChange,
  onBannerUploadingChange,
  onThumbnailUploadingChange,
  onPreview,
  isDirty,
  isSaving,
  isSaveBlocked,
  onSave,
}: ImagesCardProps) {
  const { t } = useTranslation()

  return (
    <FormSectionCard
      title={t('tour.images')}
      action={
        isEdit && (
          <SectionSaveButton
            disabled={isSaveBlocked || !isDirty}
            saving={isSaving}
            onSave={onSave}
          />
        )
      }
    >
      <div className={cn('space-y-5', !isFormReady && 'opacity-50 pointer-events-none')}>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <TourImageField
            label={t('tour.banner')}
            value={banner ?? ''}
            onChange={onBannerChange}
            onUploadingChange={onBannerUploadingChange}
            onPreview={onPreview}
          />
          <TourImageField
            label={t('tour.thumbnail')}
            value={thumbnail ?? ''}
            onChange={onThumbnailChange}
            onUploadingChange={onThumbnailUploadingChange}
            onPreview={onPreview}
          />
        </div>
      </div>
    </FormSectionCard>
  )
}
